import { motion } from "framer-motion";

// Wraps a single route's content. Runs on mount (route enter) and unmount
// (route leave) via parent AnimatePresence in App.js.
// Adds: full-screen curtain sweep + inner content fade-up.
const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    >
      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -12 }}
        transition={{ duration: 0.6, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.div>

      {/* Enter curtain — six violet slats retract downward */}
      <motion.div
        aria-hidden
        className="fixed inset-0 z-[65] pointer-events-none flex"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.01, delay: 0.9 }}
      >
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <motion.div
            key={i}
            className={`flex-1 origin-bottom ${
              i % 2 === 0 ? "bg-[#140A3D]" : "bg-[#26155F]"
            }`}
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0 }}
            transition={{
              delay: 0.05 + i * 0.055,
              duration: 0.7,
              ease: [0.83, 0, 0.17, 1],
            }}
          />
        ))}
      </motion.div>

      {/* Exit curtain — sweeps up before the next route mounts */}
      <motion.div
        aria-hidden
        className="fixed inset-0 z-[66] pointer-events-none flex"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0 }}
        exit={{ opacity: 1 }}
        transition={{ duration: 0.01 }}
      >
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <motion.div
            key={`exit-${i}`}
            className={`flex-1 origin-top ${
              i % 2 === 0 ? "bg-[#140A3D]" : "bg-[#26155F]"
            }`}
            initial={{ scaleY: 0 }}
            exit={{ scaleY: 1 }}
            transition={{
              delay: i * 0.05,
              duration: 0.5,
              ease: [0.83, 0, 0.17, 1],
            }}
          />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default PageTransition;
